import { Fragment } from 'react';

import { HorizontalDivider, Stack } from '@myphx-engineering/phx-design-system';

import type { BasicPrescriberOrderFragment } from '../../../../util';

import { MedicationOrder } from './MedicationOrder';

export type MedicationOrdersProps = {
    orders: BasicPrescriberOrderFragment[];
    showAll?: boolean;
};

export const MedicationOrders = ({
    orders,
    showAll,
}: MedicationOrdersProps) => {
    return (
        <Stack gap="sm" role="list">
            {orders
                .slice(0, showAll ? orders.length : 3)
                .map((medication, idx) => {
                    return (
                        <Fragment key={medication.id}>
                            {idx > 0 && <HorizontalDivider />}
                            <MedicationOrder order={medication} />
                        </Fragment>
                    );
                })}
        </Stack>
    );
};
